var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.995,
    height: 81.28,
    viewBox: "0 0 89.995 81.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics_sq-01-square",
    transform: "translate(0.53 0.53)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 32.274,
    cy: 32.274,
    rx: 32.274,
    ry: 32.274,
    transform: "translate(12.087 11.628)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 21.032,
    x2: 21.032,
    transform: "translate(67.224 0)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 20.009,
    y2: 20.017,
    transform: "translate(68.528 59.754)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 18.987,
    y2: 18.987,
    transform: "translate(0 7.796)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80242",
    "data-name": "Path 80242",
    d: "M117.968,10.83v5.188H112.78",
    transform: "translate(-29.253 63.982)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 1.312,
    y2: 1.312,
    transform: "translate(19.12 26.916)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 16.111,
    y2: 16.111,
    transform: "translate(22.018 29.814)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "5.04 3.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80243",
    "data-name": "Path 80243",
    d: "M52.59,53.97,53.9,55.282l1.3-1.312",
    transform: "translate(-13.668 -7.252)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y1: 3.342,
    x2: 3.342,
    transform: "translate(43.087 41.827)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "4.91 2.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80244",
    "data-name": "Path 80244",
    d: "M63.77,64.692l1.3-1.312,1.312,1.312",
    transform: "translate(-16.563 -23.636)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 16.074,
    y2: 16.082,
    transform: "translate(51.409 42.635)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "5.03 3.02"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 1.304,
    y2: 1.312,
    transform: "translate(68.276 59.502)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 3.705,
    height: 3.705,
    transform: "translate(51.11 39.776) rotate(135)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 3.705,
    height: 3.705,
    transform: "translate(42.849 48.031) rotate(135)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 3.705,
    height: 3.705,
    transform: "translate(72.597 60.146) rotate(90)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 3.705,
    height: 3.705,
    transform: "translate(19.861 23.944) rotate(90)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80245",
    "data-name": "Path 80245",
    d: "M24.456,24.456V5.188H5.188V24.456H24.456m5.188,5.188H0V0H29.643Z",
    transform: "translate(44.361 22.941) rotate(45)",
    fill: "#12784a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco4);
export default __webpack_public_path__ + "static/media/ico4.c59976442d8fc3e3b6f9f3ae3f488ed9.svg";
export { ForwardRef as ReactComponent };